// extracted by mini-css-extract-plugin
export default {"container":"titulo_container__I0xDw","titulo":"titulo_titulo__zu4eZ"};